import axiosConfig from "./axiosConfig";

// Get orders list with filters
export const getOrders = async (filters = {}) => {
  try {
    const params = {
      page: filters.page || 1,
      page_size: filters.page_size || 25,
    };

    if (filters.status && filters.status !== "all") {
      params.status = filters.status;
    }
    if (filters.search) {
      params.search = filters.search;
    }
    if (filters.date_filter) {
      params.filter_date = filters.date_filter;
    }

    const response = await axiosConfig.get("/website/orders/", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};

// Get order detail by ID
export const getOrderDetail = async (orderId) => {
  try {
    const response = await axiosConfig.get(`/website/orders/${orderId}/`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching order detail:", error);
    throw error;
  }
};

// Get order statistics
export const getOrderStats = async () => {
  try {
    const response = await axiosConfig.get("/website/orders/count/");
    return response.data.data;
  } catch (error) {
    console.error("Error fetching order stats:", error);
    throw error;
  }
};

// Update order status
export const updateOrderStatus = async (orderId, status) => {
  try {
    const response = await axiosConfig.patch(`/website/orders/${orderId}/status/`, { status });
    return response.data;
  } catch (error) {
    console.error("Error updating order status:", error);
    throw error;
  }
};

// Update order item
export const updateOrderItem = async (orderId, itemId, data) => {
  try {
    const response = await axiosConfig.patch(`/website/orders/${orderId}/items/${itemId}/`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating order item:", error);
    throw error;
  }
};

